import React from "react";
import { useAuth } from "../context/AuthContext";
import { PageHeader } from "../components/domain/Bits";
import Dashboard from "./tenant/Dashboard";
import { Link } from "react-router-dom";
import { Building2, Contact2, KanbanSquare, Settings2, FileClock, Shield, LayoutDashboard } from "lucide-react";

const cards = (isPlatform) => isPlatform ? [
  { to: "/platform", icon: LayoutDashboard, title: "Control Center", desc: "Platform portfolio and operational alerts" },
  { to: "/platform/tenants", icon: Building2, title: "Tenants", desc: "Manage tenant accounts" },
  { to: "/platform/support-access", icon: Shield, title: "Support Access", desc: "Auditable tenant access sessions" },
] : [
  { to: "/contacts", icon: Contact2, title: "Contacts", desc: "Lifecycle, dispositions, duplicates" },
  { to: "/opportunities", icon: KanbanSquare, title: "Opportunities", desc: "Kanban board · atomic stage moves" },
  { to: "/config", icon: Settings2, title: "Configuration", desc: "Read-only viewer for applied template" },
  { to: "/audit", icon: FileClock, title: "Audit Log", desc: "Append-only mutation history" },
];

export default function Home() {
  const { user } = useAuth();
  const isPlatform = user?.scope === "platform";
  // Tenant users enter the role-scoped operational dashboard.
  if (!isPlatform) {
    return <Dashboard />;
  }
  return (
    <>
      <PageHeader title={`Welcome, ${user?.name || "there"}`} subtitle="Platform operator console" />
      <div className="max-w-7xl mx-auto p-6 md:p-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {cards(isPlatform).map(({ to, icon: Icon, title, desc }) => (
            <Link key={to} to={to} className="block border border-slate-200 rounded-lg bg-white p-5 hover:border-slate-400 hover:shadow-sm transition-all"
              data-testid={`home-card-${title.toLowerCase().replace(/\s+/g,'-')}`}>
              <Icon className="w-5 h-5 text-slate-700" />
              <div className="mt-3 font-semibold tracking-tight" style={{ fontFamily: "Manrope" }}>{title}</div>
              <div className="text-sm text-slate-500 mt-1">{desc}</div>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}
